import React, { useState, useEffect } from "react";
import {
  NumberInput,
  Modal,
  Group,
  ActionIcon,
  Button,
  Title,
  rem,
} from "@mantine/core";
import {
  IconInfinity,
  IconMinus,
  IconKeyboard,
  IconPlus,
} from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

const buttonProps = {
  variant: "light",
  radius: "xl",
  color: "gray",
};

export default function Counter({
  maxValue = null,
  minValue = 0,
  onChange,
  value = "",
  unlimited = true,
}) {
  const { t } = useTranslation();
  const [isOpen, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  function onClose() {
    if ([undefined, ""].includes(inputValue)) {
      onChange(0);
    } else {
      onChange(inputValue);
    }

    setOpen(false);
  }

  return (
    <React.Fragment>
      <Modal opened={isOpen} onClose={onClose} title={t("common:manual_entry")}>
        <NumberInput
          value={value}
          onChange={(e) => {
            if (maxValue && e > maxValue) return setInputValue(maxValue);
            if (typeof e === "number") {
              setInputValue(e);
            }
          }}
          hideControls
          size="lg"
        />
        <Button fullWidth mt="sm" onClick={onClose}>
          {t("common:update")}
        </Button>
      </Modal>
      <Group>
        <ActionIcon
          {...buttonProps}
          onClick={() => onChange(value - 1)}
          disabled={value <= minValue}
        >
          <IconMinus style={{ width: rem(16), height: rem(16) }} />
        </ActionIcon>
        <ActionIcon
          {...buttonProps}
          onClick={() => onChange(value + 1)}
          disabled={maxValue ? value >= maxValue : false}
        >
          <IconPlus style={{ width: rem(16), height: rem(16) }} />
        </ActionIcon>
        <ActionIcon variant="subtle" color="gray" onClick={() => setOpen(true)}>
          <IconKeyboard />
        </ActionIcon>
        {unlimited && (
          <ActionIcon
            variant="subtle"
            color="gray"
            onClick={() => onChange(-1)}
            disabled={!unlimited}
          >
            <IconInfinity />
          </ActionIcon>
        )}
        <Title c="var(--mantine-color-dark-4)" order={2}>
          {value === -1 ? t("common:unlimited") : value}
        </Title>
      </Group>
    </React.Fragment>
  );
}
